function getMetaTagValue$1(tagName) {
  const element = document.querySelector(`meta[name='${tagName}']`);
  return element == null ? void 0 : element.getAttribute("content");
}
const PAGE_BRAND$1 = getMetaTagValue$1("page-brand");
const PAGE_COUNTRY = getMetaTagValue$1("page-country");
getMetaTagValue$1("page-country-title");
const PAGE_LANGUAGE = getMetaTagValue$1("page-language");
getMetaTagValue$1("page-skin");
const PAGE_MARKET = `${PAGE_LANGUAGE}-${PAGE_COUNTRY}`;
getMetaTagValue$1("page-country-phone-code");
getMetaTagValue$1("mopar-dam-path");
getMetaTagValue$1("accessory-assets-source-path");
`${getMetaTagValue$1("mopar-dam-path")}accessories`;
const JEEP_BRAND_ID = 57;
const FIAT_BRAND_ID = 0;
const CHRYSLER_BRAND_ID = 55;
const DODGE_BRAND_ID = 55;
const RAM_BRAND_ID = 58;
const CITROEN_BRAND_ID = 59;
const PEUGEOT_BRAND_ID = 60;
const BRAND = {
  FIAT: "fiat",
  FIAT_FLAG: "fiat-flag",
  FIAT_ABARTH: "fiat-abarth",
  JEEP: "jeep",
  RAM: "ram",
  DODGE: "dodge",
  CHRYSLER: "chrysler",
  CITROEN: "citroen",
  CITROEN2: "citroen-2",
  PEUGEOT: "peugeot"
};
const BRANDS_IDS = {
  [BRAND.JEEP]: JEEP_BRAND_ID,
  [BRAND.FIAT]: FIAT_BRAND_ID,
  [BRAND.DODGE]: DODGE_BRAND_ID,
  [BRAND.RAM]: RAM_BRAND_ID,
  [BRAND.CITROEN]: CITROEN_BRAND_ID,
  [BRAND.CHRYSLER]: CHRYSLER_BRAND_ID,
  [BRAND.PEUGEOT]: PEUGEOT_BRAND_ID
};
const PAGE_BRAND_ID = BRANDS_IDS[`${BRAND[`${PAGE_BRAND$1 == null ? void 0 : PAGE_BRAND$1.toUpperCase()}`]}`];
getMetaTagValue$1("mvs-code");
getMetaTagValue$1("year");
getMetaTagValue$1("fuel-labels") ? JSON.parse(getMetaTagValue$1("fuel-labels")) : {};
getMetaTagValue$1("current-car-models") ? JSON.parse(getMetaTagValue$1("current-car-models")) : "";
const COOKIE_AUTH = "Wisdom_id_jwt";
function getMetaTagValue(tagName) {
  const element = document.querySelector(`meta[name='${tagName}']`);
  return element == null ? void 0 : element.getAttribute("content");
}
getMetaTagValue("page-brand");
getMetaTagValue("page-country");
getMetaTagValue("page-country-title");
getMetaTagValue("page-language");
getMetaTagValue("page-skin");
getMetaTagValue("page-country-phone-code");
const DEFAULT_TTL = 144e5;
getMetaTagValue$1("location-ttl") || DEFAULT_TTL;
const SSO_CONTEXT = getMetaTagValue$1("sso-context");
const DEALER_CONTEXT_HEADER = "x-hub-dealer-context";
getMetaTagValue$1("leads-allowed-without-cpf") ? JSON.parse(getMetaTagValue$1("leads-allowed-without-cpf")) : null;
getMetaTagValue$1("enables-cpf-cnpj-in-lead-form") === "true";
getMetaTagValue$1("enable-sending-lead-for-cities-without-influence-area") === "true";
getMetaTagValue$1("lgpd-lead-privacy-policy");
const PROGRAM_SEARCH_FILTER = getMetaTagValue$1("program-search-filter") || "";
PROGRAM_SEARCH_FILTER.replace(/\|/g, "/");
getMetaTagValue$1("enable-subsidized-price") ? JSON.parse(getMetaTagValue$1("enable-subsidized-price")) : false;
getMetaTagValue$1("enable-chat-bot") === "true";
getMetaTagValue$1("facebook-app-id");
getMetaTagValue$1("user-data-salesforce-integration");
getMetaTagValue$1("google-app-id");
getMetaTagValue$1("google-analytics-product");
getMetaTagValue$1("google-analytics-segment");
getMetaTagValue$1("gatrackid");
getMetaTagValue$1("disable-appstate-mutations");
getMetaTagValue$1("cognito-user-pool-id");
getMetaTagValue$1("cognito-app-client-id");
getMetaTagValue$1("cognito-region");
getMetaTagValue$1("cognito-identity-pool-id");
const AWS_LOCATION_API_KEY = getMetaTagValue$1("aws-location-api-key");
const AWS_LOCATION_REGION = getMetaTagValue$1("aws-location-region");
const LOCATION_PROVIDER = getMetaTagValue$1("location-provider");
const AUTH_SERVICE_URL = getMetaTagValue$1("auth-service-url");
const B2E_SERVICE_URL = getMetaTagValue$1("b2e-service-url");
const B2E_SEARCH_URL = getMetaTagValue$1("b2e-search-url");
const CAR_SERVICE_URL = getMetaTagValue$1("car-service-url");
const CONFIAT_SERVICE_URL = getMetaTagValue$1("confiat-service-url");
const CONTACT_US_SERVICE_URL = getMetaTagValue$1("contact-us-service-url");
const DEALER_SALES_SERVICE_URL = getMetaTagValue$1("dealer-sales-service-url");
const DEALER_SCHEDULER_SERVICE_URL = getMetaTagValue$1("dealerscheduler-service-url");
const DEALER_SERVICE_URL = getMetaTagValue$1("dealer-service-url");
const DICTIONARY_SERVICE_URL = getMetaTagValue$1("dictionary-service-url");
getMetaTagValue$1("document-uploader-service-url");
const EVALUATE_SERVICE_URL = getMetaTagValue$1("evaluate-service-url");
getMetaTagValue$1("event-context-aws-url");
const EVENTS_SERVICE_URL = getMetaTagValue$1("event-service-url");
const FACE_IDENTITY_SERVICE_URL = getMetaTagValue$1("face-identity-service-url");
getMetaTagValue$1("fca-bmc-api-url");
const FINANCING_SERVICE_URL = getMetaTagValue$1("financing-service-url");
const FINANCING_HUB_SERVICE_URL = getMetaTagValue$1("financing-hub-service-url");
getMetaTagValue$1("game-service-url");
const GARAGE_SERVICE_URL = getMetaTagValue$1("garage-service-url");
const IDENTITY_VALIDATION_SERVICE_URL = getMetaTagValue$1("identity-validation-service");
const INTEGRATION_LOG_SERVICE_URL = getMetaTagValue$1("integrationlog-service-url");
const JOURNEY_SERVICE_URL = getMetaTagValue$1("journey-service-url");
const LEAD_INTEGRATION_URL_V2 = getMetaTagValue$1("lead-integration-url-v2");
const LOCATION_SERVICE_URL = getMetaTagValue$1("location-service-url");
const LOYALTY_SERVICE_URL = getMetaTagValue$1("loyalty-service-url");
const MAINTENENCE_SERVICE_URL = getMetaTagValue$1("maintenance-service-url");
const MANUAL_SERVICE_URL = getMetaTagValue$1("manual-service-url");
getMetaTagValue$1("models-url") ? JSON.parse(getMetaTagValue$1("models-url")) : "";
const MOPAR_SERVICE_URL = getMetaTagValue$1("mopar-service-url");
getMetaTagValue$1("moparoffer-service-url");
const MVS_SERVICE_URL = getMetaTagValue$1("mvs-service-url");
const OFFER_ADMIN_SERVICE_URL = getMetaTagValue$1("offer-admin-service-url");
getMetaTagValue$1("offer-site-url");
const PART_SERVICE_URL = getMetaTagValue$1("part-service-url");
const PRICE_SERVICE_URL = getMetaTagValue$1("price-service-url");
getMetaTagValue$1("procedure-service-url");
const RATING_SERVICE_URL = getMetaTagValue$1("rating-service-url");
const RECALL_SERVICE_URL = getMetaTagValue$1("recall-service-url");
const RENTAL_OFFER_SERVICE_URL = getMetaTagValue$1("rental-offer-service-url");
const RESERVATION_SERVICE_URL = getMetaTagValue$1("reservation-service-url");
getMetaTagValue$1("search-response-domains-url");
getMetaTagValue$1("sso-partner-service-url");
getMetaTagValue$1("stock-service-url");
const USER_ANALYTICS_SERVICE_URL = getMetaTagValue$1("user-analytics-service-url");
const USER_SERVICE_URL = getMetaTagValue$1("user-service-url");
getMetaTagValue$1("visitant-schedule-url");
const VISIT_SCHEDULING_SERVICE_URL = getMetaTagValue$1("visit-scheduling-service-url");
const VOUCHER_HUB_SERVICE_URL = getMetaTagValue$1("voucher-hub-service-url");
getMetaTagValue$1("whatsapp-api-url");
const QUIZ_SERVICE_URL = getMetaTagValue$1("quiz-service-url");
const VERSION_COMPARATOR_URL = getMetaTagValue$1("version-comparator-service-url");
const RENTAL_USER_SERVICE_URL = getMetaTagValue$1("rental-user-service-url");
const BENEFITS_SERVICE_URL = getMetaTagValue$1("benefits-service-url");
getMetaTagValue$1("benefits-service-hub-url");
const NEW_OFFER_SEARCH_URL = getMetaTagValue$1("new-offer-search-url");
const PAYMENT_SECURITY_SERVICE_URL = getMetaTagValue$1("payment-security-service-url");
getMetaTagValue$1("transaction-pagador-url");
const LOYALTY_SUBSCRIPTION_SERVICE_URL = getMetaTagValue$1("loyalty-subscription-service-url");
getMetaTagValue$1("org-id");
const PROMOTION_SERVICE_URL = getMetaTagValue$1("promotion-service-url");
export {
  AUTH_SERVICE_URL,
  AWS_LOCATION_API_KEY,
  AWS_LOCATION_REGION,
  B2E_SEARCH_URL,
  B2E_SERVICE_URL,
  BENEFITS_SERVICE_URL,
  BRAND,
  BRANDS_IDS,
  CAR_SERVICE_URL,
  CHRYSLER_BRAND_ID,
  CITROEN_BRAND_ID,
  CONFIAT_SERVICE_URL,
  CONTACT_US_SERVICE_URL,
  COOKIE_AUTH,
  DEALER_CONTEXT_HEADER,
  DEALER_SALES_SERVICE_URL,
  DEALER_SCHEDULER_SERVICE_URL,
  DEALER_SERVICE_URL,
  DEFAULT_TTL,
  DICTIONARY_SERVICE_URL,
  DODGE_BRAND_ID,
  EVALUATE_SERVICE_URL,
  EVENTS_SERVICE_URL,
  FACE_IDENTITY_SERVICE_URL,
  FIAT_BRAND_ID,
  FINANCING_HUB_SERVICE_URL,
  FINANCING_SERVICE_URL,
  GARAGE_SERVICE_URL,
  IDENTITY_VALIDATION_SERVICE_URL,
  INTEGRATION_LOG_SERVICE_URL,
  JEEP_BRAND_ID,
  JOURNEY_SERVICE_URL,
  LEAD_INTEGRATION_URL_V2,
  LOCATION_PROVIDER,
  LOCATION_SERVICE_URL,
  LOYALTY_SERVICE_URL,
  LOYALTY_SUBSCRIPTION_SERVICE_URL,
  MAINTENENCE_SERVICE_URL,
  MANUAL_SERVICE_URL,
  MOPAR_SERVICE_URL,
  MVS_SERVICE_URL,
  NEW_OFFER_SEARCH_URL,
  OFFER_ADMIN_SERVICE_URL,
  PAGE_BRAND$1 as PAGE_BRAND,
  PAGE_BRAND_ID,
  PAGE_COUNTRY,
  PAGE_LANGUAGE,
  PAGE_MARKET,
  PART_SERVICE_URL,
  PAYMENT_SECURITY_SERVICE_URL,
  PEUGEOT_BRAND_ID,
  PRICE_SERVICE_URL,
  PROGRAM_SEARCH_FILTER,
  PROMOTION_SERVICE_URL,
  QUIZ_SERVICE_URL,
  RAM_BRAND_ID,
  RATING_SERVICE_URL,
  RECALL_SERVICE_URL,
  RENTAL_OFFER_SERVICE_URL,
  RENTAL_USER_SERVICE_URL,
  RESERVATION_SERVICE_URL,
  SSO_CONTEXT,
  USER_ANALYTICS_SERVICE_URL,
  USER_SERVICE_URL,
  VERSION_COMPARATOR_URL,
  VISIT_SCHEDULING_SERVICE_URL,
  VOUCHER_HUB_SERVICE_URL
};
